import { InquiryFileStatus } from '@/types/chat/chat';

export const isInquiryFileProcessingTerminal = (
  status: InquiryFileStatus['status'],
) => status === 'finished_processing' || status === 'failed';

export const hasInProgressInquiryFiles = (
  files: InquiryFileStatus[],
): boolean => files.some(file => !isInquiryFileProcessingTerminal(file.status));

export const shouldBlockSendForProcessingFiles = (
  chatMode: string,
  files: InquiryFileStatus[],
  filesLoading: boolean,
): boolean => {
  if (chatMode === 'chat_only') {
    return false;
  }

  return filesLoading || hasInProgressInquiryFiles(files);
};
